import { type FC, useState } from "react";
import { IconButton, Menu } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTranslation } from "react-i18next";
import { ActionMenuItem } from "@/shared/components/BulkActions";

interface ProductActionsMenuProps {
  onCancelEvent(): void;
}

/**
 * Меню действий в шапке карточки PPV-продукта: «Отменить событие».
 * Видимость (PPV, право EventCancel, отмены ещё не было) решает родитель.
 */
export const ProductActionsMenu: FC<ProductActionsMenuProps> = ({
  onCancelEvent,
}) => {
  const { t } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        aria-label={t("products.eventCancel.actionsLabel")}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
      >
        <ActionMenuItem
          onClick={() => {
            setAnchor(null);
            onCancelEvent();
          }}
        >
          {t("products.eventCancel.menuItem")}
        </ActionMenuItem>
      </Menu>
    </>
  );
};
